<template>
  <div>
    <v-snackbar class="snakbar-sty rounded-pill" transition="slide-x-reverse-transition" v-model="snackbar" :timeout="3000" :value="true" :color="snackbarclr" absolute outlined>
      <v-icon class="mr-2" :color="snackbarclr">mdi-alert-outline</v-icon>
      {{ snackmsgbar }}
      <v-icon @click="snackbar = false" class="float-right" :color="snackbarclr">mdi-close-circle</v-icon>
    </v-snackbar>
    <div class="body-row pb-3 px-4 px-md-6 px-lg-8 pt-lg-6">
      <zebu-logo />
      <v-card class="elevation-0">
        <p class="mynt-eyebrow font-weight-bold mb-2">Welcome to Zebu</p>
        <p class="mynt-title font-weight-bold mb-7"><span v-if="order == false">Login to MYNT</span> <span v-else>Order conformation</span></p>

        <div>
          <div v-if="order == false">
            <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="validate()">
              <v-text-field v-model="userId" :rules="useridRules" color="#0037B7" class="mynt-field mb-3" label="Client ID" required oninput="this.value = this.value.toUpperCase()"></v-text-field>

              <v-text-field
                v-model="password"
                :append-icon="pwseye ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="pwsRules"
                :type="pwseye ? 'text' : 'password'"
                color="#0037B7"
                class="mynt-field mb-3"
                label="Password"
                @click:append="pwseye = !pwseye"
              ></v-text-field>

              <v-text-field
                v-model="twofact"
                :append-icon="twofacteye ? 'mdi-eye' : 'mdi-eye-off'"
                :rules="twofacteyeRules"
                :type="twofacteye ? 'text' : 'password'"
                color="#0037B7"
                class="mynt-field mb-3"
                label="PAN/DOB/OTP"
                @click:append="twofacteye = !twofacteye"
                required
                oninput="this.value = this.value.toUpperCase()"
              ></v-text-field>

              <div class="mt-4" :style="`cursor: ${valid != true ? 'not-allowed' : 'auto'};`">
                <v-btn height="47px" :loading="loader" :disabled="!valid" type="submit" color="#0037B7" class="text-none mynt-btn elevation-0 mb-1" block> <span class="white--text mynt-btn-label">Sign In</span></v-btn>
              </div>
            </v-form>

            <p class="mb-0 mt-3">
              <v-row no-gutters>
                <v-col cols="3" class="text-left pr-3">
                  <!-- <v-btn text :ripple="false" color="primary"
                                                    class="forgotbtn px-0 mb-2 elevation-0" small @click="otpto()">
                                                    <span class="font-weight-bold text-capitalize">
                                                        GET OTP
                                                    </span>
                                                </v-btn> -->
                </v-col>
                <v-col cols="9" class="text-right">
                  <v-list-item-title>
                    <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small target="_blank" href="https://sso.mynt.in/forgot_password" @click="forgotPws()">
                      <span class="mynt-link text-none"> Forgot password</span>
                    </v-btn></v-list-item-title
                  >
                </v-col>
              </v-row>
            </p>
          </div>

          <div v-else-if="order">
            <v-list-item>
              <v-list-item-avatar color="teal" size="48">
                <span class="font-weight-bold white--text title">{{ this.userdata.uid.slice(0, 1) }}</span>
              </v-list-item-avatar>
              <v-list-item-content class="text-left font-weight-bold">
                <v-list-item-title>{{ this.userdata.name }}</v-list-item-title>
                <v-list-item-subtitle>{{ this.userdata.uid }}</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>

            <v-list-item>
              <v-list-item-content class="text-left font-weight-bold">
                <v-list-item-subtitle>Script :</v-list-item-subtitle>
                <v-list-item-subtitle>Lot :</v-list-item-subtitle>
                <v-list-item-subtitle>B/S :</v-list-item-subtitle>
                <v-list-item-subtitle>Order Vai :</v-list-item-subtitle>
                <v-list-item-subtitle>Order Type :</v-list-item-subtitle>
                <v-list-item-subtitle>Price :</v-list-item-subtitle>
              </v-list-item-content>
              <v-list-item-content class="text-left font-weight-bold">
                <v-list-item-title>{{ `${userdata.exch}:${userdata.tsym}` }}</v-list-item-title>
                <v-list-item-title>{{ userdata.qty }}</v-list-item-title>
                <v-list-item-title>{{ userdata.trantype }}</v-list-item-title>
                <v-list-item-title>{{ userdata.prd }}</v-list-item-title>
                <v-list-item-title>{{ userdata.prctyp }}</v-list-item-title>
                <v-list-item-title>{{ userdata.prc }}</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-btn height="47px" color="#FF9800" class="text-none mynt-btn elevation-0 mb-1" block :disabled="ordbtn" :loading="loader" @click="placeOrder()">
              <span class="white--text mynt-btn-label"> Place Order </span>
            </v-btn>
            <p class="mb-0 mt-3">
              <v-row no-gutters>
                <v-col cols="3" class="text-left pr-3">
                  <!--  -->
                </v-col>
                <v-col cols="9" class="text-right">
                  <v-btn text :ripple="false" color="#0037B7" class="px-0 mb-2 elevation-0" small @click="swacc()">
                    <span class="mynt-link text-none"> Switch account </span>
                  </v-btn>
                </v-col>
              </v-row>
            </p>
          </div>
          <div v-else>
            <v-card width="100%" class="text-center py-16 elevation-0 mt-10">
              <v-progress-circular class="mx-auto" :size="60" :width="4" color="#0037B7" indeterminate></v-progress-circular>
            </v-card>
          </div>
          <p class="mynt-signup mb-0 text-center mt-6">Don't have an account yet? <a class="mynt-link" style="text-decoration: none" href="https://oa.mynt.in?ref=desk">Sign Up</a></p>
        </div>
      </v-card>
      <v-footer padless absolute color="#fff">
        <v-col class="text-center font-weight-medium fs-13 px-lg-8 px-md-6 px-lg-8 pb-2 mynt-legal" cols="12"
          ><span class="font-weight-bold fs-14 black--text"> Zebu Share and Wealth Managements Pvt. Ltd. </span><br />
          SEBI Registration No: INZ000174634 | NSE : 13179 | BSE : 6550 | MCX : 55730 | CDSL : 12080400 | AMFI ARN : 113118 | Research Analyst : INH200006044
        </v-col>
      </v-footer>
    </div>
  </div>
</template>

<script>
import axios from "axios";
// import { sha256 } from "js-sha256";
import {mynturl, oredurl, vc} from "../apiUrl.js";
import ZebuLogo from "./ZebuLogo.vue";

export default {
  components: {ZebuLogo},

  data: () => ({
    snackbar: false,
    snackbarclr: "default",
    snackmsgbar: "",
    // signinform: true,
    valid: true,
    userId: "",
    useridRules: [(v) => !!v || "Client Id is required"],
    pwseye: false,
    password: "",
    pwsRules: [(v) => !!v || "Password is required"],

    twofacteye: false,
    twofact: "",
    twofacteyeRules: [
      (v) => !!v || "PAN/DOB/OTP is required",
      (v) => v.length >= 4 || "PAN/DOB/OTP of minimum 4 characters or must be valid",
      // v => /[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(v) || 'PAN number must be valid',
    ],
    theme: "Light",
    userdata: [],
    order: null,
    loader: null,
    ordbtn: null,
  }),

  async created() {
    this.theme = "Dark";
  },

  mounted() {
    this.userdata["uid"] = localStorage.getItem("pubuid");
    this.userdata["susertoken"] = localStorage.getItem("pubtok");
    this.userdata["name"] = localStorage.getItem("pubname");

    var url = new URL(window.location.href);
    this.userId = url.searchParams.get("uid");
    this.password = url.searchParams.get("pws");
    this.twofact = url.searchParams.get("2fa");

    var data = `jData={"uid":"${this.userdata.uid}"}&jKey=${this.userdata.susertoken}`;

    var udmyntconfig = {
      method: "post",
      url: `${mynturl}/UserDetails`,
      headers: {
        "Content-Type": "text/plain",
      },
      data: data,
    };
    var axiosThis = this;
    axios(udmyntconfig)
      .then(function (response) {
        if (response.data && response.data.stat == "Ok") {
          axiosThis.getValues();
        } else {
          axiosThis.order = false;
        }
      })
      .catch(function (error) {
        console.log(error);
        axiosThis.order = false;
      });
  },

  methods: {
    getValues() {
      var url = new URL(window.location.href);
      this.userdata["exch"] = url.searchParams.get("exch");
      this.userdata["prctyp"] = url.searchParams.get("prctyp");
      this.userdata["prd"] = url.searchParams.get("prd");
      this.userdata["prc"] = url.searchParams.get("prc");
      this.userdata["lmtprc"] = url.searchParams.get("lmtprc");
      this.userdata["qty"] = url.searchParams.get("qty");
      this.userdata["ret"] = url.searchParams.get("ret");
      this.userdata["tsym"] = url.searchParams.get("tsym");
      this.userdata["trantype"] = url.searchParams.get("trantype");
      this.userdata["trgprc"] = url.searchParams.get("trgprc");
      this.userdata["discqty"] = url.searchParams.get("discqty");
      this.userdata["bpprc"] = url.searchParams.get("bpprc");
      this.userdata["blprc"] = url.searchParams.get("blprc");

      this.order = true;
    },
    swacc() {
      localStorage.clear();
      window.location.reload();
    },
    validate() {
      // var shapass = sha256(this.password);
      // var addak = this.userId + apikey;
      // var appkey = sha256(addak);
      if (this.$refs.form.validate() != false) {
        this.loader = true;
        let config = {
          method: "post",
          url: `${oredurl}?uid=${this.userId}&pwd=${encodeURIComponent(this.password)}&factor2=${this.twofact}&vc=${vc}`,
          headers: {},
        };

        let axiosThis = this;
        axios
          .request(config)
          .then((response) => {
            axiosThis.userdata = [];
            if (response.data.susertoken && response.data.uid) {
              axiosThis.userdata = response.data;
              localStorage.setItem("pubuid", response.data.uid);
              localStorage.setItem("pubtok", response.data.susertoken);
              localStorage.setItem("pubname", response.data.uname);
              axiosThis.userdata["name"] = response.data.uname;
              axiosThis.getValues();
            } else if (response.data.emsg == "Invalid Input : Invalid User") {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              axiosThis.snackmsgbar = "Invalid User or Invalid Client ID";
              axiosThis.userId = "";
              axiosThis.password = "";
              axiosThis.twofact = "";
            } else if (response.data.emsg == "Invalid Input : Wrong Password") {
              // console.log("uid else if w-pws", response.data.emsg);
              // axiosThis.signinform = true;
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "warning";
              axiosThis.snackmsgbar = "Wrong Password.";
              axiosThis.password = "";
            } else if (response.data.emsg == "Invalid Input : Invalid OTP") {
              // console.log("uid else if otp", response.data.emsg);
              // axiosThis.signinform = true;
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "warning";
              axiosThis.snackmsgbar = "Invalid OTP.";
              axiosThis.twofact = "";
            } else if (response.data.emsg == "Invalid Input : Wrong PAN/DOB") {
              // console.log("uid else if 2fa", response.data.emsg);
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "warning";
              axiosThis.snackmsgbar = "Wrong PAN/DOB number.";
              axiosThis.twofact = "";
            } else if (response.data.emsg == "Invalid Input : Deactivated") {
              // console.log("uid else if Deactivated", response.data.emsg);
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "warning";
              axiosThis.snackmsgbar = "Deactivated.";
              axiosThis.twofact = "";
            } else if (response.data.emsg == "Session Expired :  Invalid Session Key" || response.data.emsg == "Session Expired : Invalid Session Key") {
              // console.log("uid else if Invalid Session Key", response.data.emsg);
              axiosThis.snackbar = false;
              axiosThis.snackbarclr = "warning";
              axiosThis.snackmsgbar = "Invalid Session Key.";
            } else if (response.data.emsg == "Invalid Input : Invalid Access Type") {
              // console.log("uid else if  Invalid Access Type", response.data.emsg);
              axiosThis.snackbar = false;
              axiosThis.snackbarclr = "warning";
              axiosThis.snackmsgbar = " Invalid Access Type, Mismatch in API URL.";
            } else if (response.data.emsg == "Invalid Input : User Blocked due to multiple wrong attempts") {
              // console.log("uid else if for pws", response.data.emsg);
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              axiosThis.snackmsgbar = "User Blocked due to multiple wrong attempts.";
              setTimeout(function () {
                window.location.href = "https://sso.mynt.in/forgot_password";
                axiosThis.forgotPws();
              }, 2000);
            } else if (response.data.emsg == "Invalid Input : Change Password" || response.data.emsg == "Invalid Input : Password Expired") {
              // console.log("uid else if cng", response.data.emsg);
              // axiosThis.signinform = true;
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "warning";
              if (response.data.emsg == "Invalid Input : Change Password") {
                axiosThis.snackmsgbar = "Password as Change, please set new Password.";
              } else if (response.data.emsg == "Invalid Input : Password Expired") {
                axiosThis.snackmsgbar = "Password Expired, please Change Password.";
              }
              axiosThis.userId = "";
              axiosThis.password = "";
              axiosThis.twofact = "";
              setTimeout(function () {
                window.location.href = "https://sso.mynt.in/change_password";
                axiosThis.forgotPws();
              }, 2000);
            } else {
              axiosThis.snackbar = true;
              axiosThis.snackbarclr = "#f23645";
              if (response.data.emsg) {
                axiosThis.snackmsgbar = response.data.emsg;
              } else {
                axiosThis.snackmsgbar = "something went wrong, Kindly Sign in.";
              }
              axiosThis.usertheme = axiosThis.theme;
              axiosThis.userautosave = axiosThis.knowautosave;
              let routrs = localStorage.getItem("routset");
              localStorage.clear();
              localStorage.setItem("routset", routrs);
              localStorage.setItem("theme", axiosThis.usertheme);
              localStorage.setItem("autoSave", axiosThis.userautosave);
              axiosThis.userId = "";
              axiosThis.password = "";
              axiosThis.twofact = "";
            }
            axiosThis.loader = false;
          })
          .catch((error) => {
            console.log(error);
          });
      }
    },
    // otpto() {
    //     this.$router.push("/OTP_sigin");
    // },
    forgotPws() {
      window.close();
    },
    // getScriptQuote() {
    //     var url = new URL(window.location.href);
    //     let occonfig = {
    //         method: "post",
    //         url: `${mynturl}/GetQuotes`,
    //         headers: {
    //             "Content-Type": "text/plain",
    //         },
    //         data: `jData={"uid":"${this.userdata.uid}","exch":"${url.searchParams.get("exch")}","token":"${url.searchParams.get("tok")}"}&jKey=${this.userdata.susertoken}`,
    //     };
    //     let axiosThis = this;
    //     axios(occonfig)
    //         .then(function (response) {
    //             if (response.data && response.data.stat == 'Ok') {

    //             } else {
    //                 axiosThis.snackbar = true;
    //                 axiosThis.snackbarclr = "warning";
    //                 axiosThis.snackmsgbar = response.data;
    //             }

    //         })
    //         .catch(function (error) {
    //             console.log(error);
    //             axiosThis.snackbar = true;
    //             axiosThis.snackbarclr = "warning";
    //             axiosThis.snackmsgbar = error;
    //         });
    // },
    placeOrder() {
      this.loader = true;
      // ZSK162
      // Ragav#123
      // OKMPS2385N

      // NSE -'-EQ'
      // NFO - 'RELIANCE26OCT23P1300'
      // MCX - ''
      // BSE -
      let placeholders = {
        uid: this.userdata.uid,
        actid: this.userdata.uid,
        exch: this.userdata.exch,
        pCode: this.userdata.prd == "INTRADAY" ? "I" : this.userdata.prd == "DELIVERY" ? "C" : this.userdata.prd == "BO" ? "B" : "M",
        prctyp: this.userdata.prctyp == "STOP-LIMIT" ? "SL-LMT" : this.userdata.prctyp == "STOP" ? "SL-MKT" : this.userdata.prctyp == "LIMIT" ? "LMT" : "MKT",
        prd: this.userdata.prd == "INTRADAY" ? "I" : this.userdata.prd == "DELIVERY" ? "C" : this.userdata.prd == "BO" ? "B" : "M",
        prc: this.userdata.prctyp == "STOP-LIMIT" ? `${this.userdata.prc}` : this.userdata.prctyp == "LIMIT" ? `${this.userdata.prc}` : "0",
        qty: `${this.userdata.qty}`,
        ret: this.userdata.ret ? `${this.userdata.ret}` : "DAY",
        tsym: `${this.userdata.tsym}`,
        trantype: this.userdata.trantype == "BUY" ? "B" : "S",
        trgprc: this.userdata.prctyp == "STOP-LIMIT" ? `${this.userdata.lmtprc}` : this.userdata.prctyp == "LIMIT" ? `${this.userdata.lmtprc}` : "0",
        discqty: this.userdata.discqty ? `${this.userdata.discqty}` : "0",
        bpprc: this.userdata.bpprc ? `${this.userdata.bpprc}` : "0",
        blprc: this.userdata.blprc ? `${this.userdata.blprc}` : "0",
      };

      let data = `jData=${JSON.stringify(placeholders)}&jKey=${this.userdata.susertoken}`;
      var config = {
        method: "post",
        url: `${mynturl}/PlaceOrder`,
        headers: {
          "Content-Type": "text/plain",
        },
        data: data,
      };
      let axiosThis = this;
      axios(config)
        .then(function (response) {
          // console.log("PlaceOrder", response.data);
          if (response.data.stat == "Ok") {
            axiosThis.snackbarclr = "green";
            axiosThis.snackmsgbar = `Order placed successfully`;
            axiosThis.ordbtn = true;
            setTimeout(() => {
              window.close();
            }, 3000);
          } else {
            axiosThis.ordbtn = false;
            axiosThis.snackbarclr = "red";
            axiosThis.snackmsgbar = response.data;
          }
          axiosThis.snackbar = true;
          axiosThis.loader = false;
        })
        .catch(function (error) {
          console.log(error);
          axiosThis.ordbtn = false;
          axiosThis.snackbar = true;
          axiosThis.snackbarclr = "red";
          axiosThis.snackmsgbar = error;
        });
    },
  },
};
</script>
